export default "__VITE_ASSET__Be9AwMd5__"